// Generated by Melange

import * as Stdlib__Fun from "melange/fun.jsx";
import * as StoreFx__GoToNextSong from "./goToNextSong.jsx";
import * as StoreFx__GoToPrevSong from "./goToPrevSong.jsx";
import * as StoreFx__Pause from "./pause.jsx";
import * as StoreFx__Play from "./play.jsx";
import * as StoreFx__SetCurrentTime from "./setCurrentTime.jsx";
import * as StoreFx__StopPlaying from "./stopPlaying.jsx";

function make($$event) {
  const match = $$event.action;
  if (match === "play") {
    return StoreFx__Play.make(undefined);
  }
  if (match === "stop") {
    return StoreFx__StopPlaying.make(undefined);
  }
  if (match === "seekto") {
    const seekTime = $$event.seekTime;
    if (seekTime !== undefined) {
      return StoreFx__SetCurrentTime.make(function (param) {
        return Stdlib__Fun.$$const(seekTime, param);
      });
    } else {
      return {
        TAG: /* Ok */ 0,
        _0: undefined
      };
    }
  }
  if (match === "seekbackward") {
    const seekOffset = $$event.seekOffset;
    if (seekOffset !== undefined) {
      return StoreFx__SetCurrentTime.make(function (currentTime) {
        return currentTime - seekOffset;
      });
    } else {
      return {
        TAG: /* Ok */ 0,
        _0: undefined
      };
    }
  }
  if (match === "previoustrack") {
    return StoreFx__GoToPrevSong.make(undefined);
  }
  if (match === "nexttrack") {
    return StoreFx__GoToNextSong.make(undefined);
  }
  if (match === "pause") {
    return StoreFx__Pause.make(undefined);
  }
  const seekOffset$1 = $$event.seekOffset;
  if (seekOffset$1 !== undefined) {
    return StoreFx__SetCurrentTime.make(function (currentTime) {
      return currentTime + seekOffset$1;
    });
  } else {
    return {
      TAG: /* Ok */ 0,
      _0: undefined
    };
  }
}

export {
  make,
}
/* Stdlib__Fun Not a pure module */
